import ManageSalaryReport from '../../../views/Personnel/Report/ManageSalaryPayroll.view';

export default ManageSalaryReport;
